import { array, enums, object, string } from "superstruct";

import { CUSTOMER_DELAYED_REWARDS_TYPES } from "../constants";
import { CustomerRewardsActivitySchema } from "./RewardsCustomerRewardsActivitySchema";

export const CustomerDelayedRewardsSchema = object({
    type: enums(Object.values(CUSTOMER_DELAYED_REWARDS_TYPES)),
    rewardScheduledAt: string(),
    earningRule: CustomerRewardsActivitySchema,
});

export const CustomerDelayedRewardsResponseSchema = object({
    delayedRewards: array(CustomerDelayedRewardsSchema),
});
